import classnames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { Row } from "reactstrap";
import { RootStoreContext } from "../../app/stores/rootStore";

interface IParams {
  title: string;
}

const TitleNavbar: React.FC<IParams> = ({ title }) => {
  const rootStore = useContext(RootStoreContext);
  const { theme } = rootStore.commonStore;

  // return (
  //   <div
  //     className={classnames(
  //       "overflow-hidden w-100 titleNavbar",
  //       `${theme!.titleBarBgDocument} ${theme!.titleBarTextDocument}`
  //     )}
  //   >
  //     <Row  className="ml-2">{title}</Row>
  //   </div>
  // );
  return (
    <div
    style={{paddingLeft:"6px", paddingRight:"6px"}}
      className={classnames(
        "overflow-hidden w-100 titleNavbar text-truncate",
        `${theme!.titleBarBgDocument} ${theme!.titleBarTextDocument}`
      )}
    >
   {title}
    
    </div>
  );
};

export default observer(TitleNavbar);
